import _ from 'lodash';
import { businessQuestionService } from '@/services';
import {
    GET_ALL,
    GET_BY_PORTFOLIO_ID,
    UPDATE
  } from "./actions.type";
import {
    GET_ALL_REQUEST,
    GET_ALL_SUCCESS,
    GET_ALL_FAILURE,
    GET_BY_PORTFOLIO_ID_REQUEST,
    GET_BY_PORTFOLIO_ID_SUCCESS,
    GET_BY_PORTFOLIO_ID_FAILURE,
    CLEAR_ITEMS,
    UPDATE_LIST_ITEM
  } from "./mutations.type";

export const businessquestions = {
    namespaced: true,
    state: {
        status: {
            loading: false,
            loaded: false,
            failed: false,
            error: null
        },
        items: [],
    },
    getters: {
        
    },
    actions: {
        [GET_ALL]({ commit, state }, useCached) {
            return new Promise((resolve, reject) => {
                if (!!useCached && state.items.length > 0) {
                    resolve(state.items);
                } else {
                    commit(GET_ALL_REQUEST);

                    businessQuestionService.getAll()
                        .then(
                            questions => {
                                commit(GET_ALL_SUCCESS, questions);
                                resolve(questions);
                            },
                            error =>  {
                                commit(GET_ALL_FAILURE, error);
                                reject(error);
                            }
                        );
                }
            });
        },
        [GET_BY_PORTFOLIO_ID]({ commit }, portfolioId) {
            return new Promise((resolve, reject) => {
                commit(GET_BY_PORTFOLIO_ID_REQUEST);

                businessQuestionService.getByPortfolio(portfolioId)
                    .then(
                        questions => {
                            commit(GET_BY_PORTFOLIO_ID_SUCCESS, questions);
                            resolve(questions);
                        },
                        error =>  {
                            commit(GET_BY_PORTFOLIO_ID_FAILURE, error);
                            reject(error);
                        }
                    );
            });
        },
        [UPDATE]({ dispatch, commit }, accountQuestion) {
            return businessQuestionService.update(accountQuestion);
        }
    },
    mutations: {
        [GET_ALL_REQUEST](state) {
            state.status = { loading: true };
        },
        [GET_ALL_SUCCESS](state, questions) {
            state.status = { loaded: true };
            state.items = questions;
        },
        [GET_ALL_FAILURE](state, error) {
            state.status = { failed: true, error };
            state.items = [];
        },
        [GET_BY_PORTFOLIO_ID_REQUEST](state) {
            state.status = { loading: true };
        },
        [GET_BY_PORTFOLIO_ID_SUCCESS](state, questions) {
            state.status = { loaded: true };
            state.items = questions;
        },
        [GET_BY_PORTFOLIO_ID_FAILURE](state, error) {
            state.status = { failed: true, error };
            state.items = [];
        },
        [CLEAR_ITEMS](state) {
            state.items = [];
        },
        [UPDATE_LIST_ITEM](state, { questionId, field, value }) {
            let entity = state.items.find(i => i.questionId === questionId);
            if (entity) {
                Object.assign(entity, {
                    [field]: value
                });
            }
        },
    }
}
